/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $input: CreateUserInput!
    $condition: ModelUserConditionInput
  ) {
    createUser(input: $input, condition: $condition) {
      id
      email
      username
      firstName
      lastName
      phoneNumber
      avatar {
        bucket
        region
        key
      }
      customerID
      accountID
      credits
      files {
        items {
          id
          name
          ownerName
          trainerApplicationID
          userID
          fileType
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      application {
        id
        username
        firstName
        lastName
        isInfluencer
        isTrainer
        isOwner
        submitted
        location {
          city
          state
          zip
        }
        socials {
          instagram
          twitter
          facebook
          snapchat
          linkedin
        }
        gymStudioName
        website
        specializations {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        userID
        lastIndex
        gymStudioAddress {
          streetAddress
          city
          state
          zip
          country
        }
        files {
          nextToken
          startedAt
        }
        approved
        dateApproved
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      cognitoUserID
      classes {
        items {
          id
          userID
          name
          description
          date
          categoryFilter
          duration
          equipment
          classStatus
          classStatusString
          price
          startTime
          defaultBannerIndex
          playlist
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      profile {
        firstName
        lastName
        bio
        website
        socials {
          instagram
          twitter
          facebook
          snapchat
          linkedin
        }
        location {
          city
          state
          zip
        }
        specializations {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
      }
      userType
      userTypeString
      classCategories {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      categoryFilter
      classBookings {
        items {
          id
          classID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      reviews {
        items {
          id
          review
          rating
          classID
          userID
          instructorID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      favorites {
        items {
          id
          userID
          instructorID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      notifications {
        items {
          id
          userID
          createdAt
          pushToken
          type
          isNew
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      transactions {
        items {
          id
          credits
          classID
          finalCreditBalance
          initialCreditBalance
          type
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      pushToken
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $input: UpdateUserInput!
    $condition: ModelUserConditionInput
  ) {
    updateUser(input: $input, condition: $condition) {
      id
      email
      username
      firstName
      lastName
      phoneNumber
      avatar {
        bucket
        region
        key
      }
      customerID
      accountID
      credits
      files {
        items {
          id
          name
          ownerName
          trainerApplicationID
          userID
          fileType
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      application {
        id
        username
        firstName
        lastName
        isInfluencer
        isTrainer
        isOwner
        submitted
        location {
          city
          state
          zip
        }
        socials {
          instagram
          twitter
          facebook
          snapchat
          linkedin
        }
        gymStudioName
        website
        specializations {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        userID
        lastIndex
        gymStudioAddress {
          streetAddress
          city
          state
          zip
          country
        }
        files {
          nextToken
          startedAt
        }
        approved
        dateApproved
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      cognitoUserID
      classes {
        items {
          id
          userID
          name
          description
          date
          categoryFilter
          duration
          equipment
          classStatus
          classStatusString
          price
          startTime
          defaultBannerIndex
          playlist
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      profile {
        firstName
        lastName
        bio
        website
        socials {
          instagram
          twitter
          facebook
          snapchat
          linkedin
        }
        location {
          city
          state
          zip
        }
        specializations {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
      }
      userType
      userTypeString
      classCategories {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      categoryFilter
      classBookings {
        items {
          id
          classID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      reviews {
        items {
          id
          review
          rating
          classID
          userID
          instructorID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      favorites {
        items {
          id
          userID
          instructorID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      notifications {
        items {
          id
          userID
          createdAt
          pushToken
          type
          isNew
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      transactions {
        items {
          id
          credits
          classID
          finalCreditBalance
          initialCreditBalance
          type
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      pushToken
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $input: DeleteUserInput!
    $condition: ModelUserConditionInput
  ) {
    deleteUser(input: $input, condition: $condition) {
      id
      email
      username
      firstName
      lastName
      phoneNumber
      avatar {
        bucket
        region
        key
      }
      customerID
      accountID
      credits
      files {
        items {
          id
          name
          ownerName
          trainerApplicationID
          userID
          fileType
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      application {
        id
        username
        firstName
        lastName
        isInfluencer
        isTrainer
        isOwner
        submitted
        location {
          city
          state
          zip
        }
        socials {
          instagram
          twitter
          facebook
          snapchat
          linkedin
        }
        gymStudioName
        website
        specializations {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        userID
        lastIndex
        gymStudioAddress {
          streetAddress
          city
          state
          zip
          country
        }
        files {
          nextToken
          startedAt
        }
        approved
        dateApproved
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      cognitoUserID
      classes {
        items {
          id
          userID
          name
          description
          date
          categoryFilter
          duration
          equipment
          classStatus
          classStatusString
          price
          startTime
          defaultBannerIndex
          playlist
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      profile {
        firstName
        lastName
        bio
        website
        socials {
          instagram
          twitter
          facebook
          snapchat
          linkedin
        }
        location {
          city
          state
          zip
        }
        specializations {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
      }
      userType
      userTypeString
      classCategories {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      categoryFilter
      classBookings {
        items {
          id
          classID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      reviews {
        items {
          id
          review
          rating
          classID
          userID
          instructorID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      favorites {
        items {
          id
          userID
          instructorID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      notifications {
        items {
          id
          userID
          createdAt
          pushToken
          type
          isNew
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      transactions {
        items {
          id
          credits
          classID
          finalCreditBalance
          initialCreditBalance
          type
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      pushToken
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createTransaction = /* GraphQL */ `
  mutation CreateTransaction(
    $input: CreateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    createTransaction(input: $input, condition: $condition) {
      id
      credits
      classID
      finalCreditBalance
      initialCreditBalance
      type
      userID
      associatedClass {
        id
        userID
        instructor {
          id
          email
          username
          firstName
          lastName
          phoneNumber
          customerID
          accountID
          credits
          cognitoUserID
          userType
          userTypeString
          categoryFilter
          pushToken
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        description
        date
        categoryFilter
        category {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        duration
        equipment
        banner {
          bucket
          region
          key
        }
        intervals {
          name
          duration
          timeType
          type
          id
        }
        classStatus
        classStatusString
        price
        startTime
        defaultBannerIndex
        classBookings {
          nextToken
          startedAt
        }
        stream {
          id
          isHostInStreamRoom
          classID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        playlist
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateTransaction = /* GraphQL */ `
  mutation UpdateTransaction(
    $input: UpdateTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    updateTransaction(input: $input, condition: $condition) {
      id
      credits
      classID
      finalCreditBalance
      initialCreditBalance
      type
      userID
      associatedClass {
        id
        userID
        instructor {
          id
          email
          username
          firstName
          lastName
          phoneNumber
          customerID
          accountID
          credits
          cognitoUserID
          userType
          userTypeString
          categoryFilter
          pushToken
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        description
        date
        categoryFilter
        category {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        duration
        equipment
        banner {
          bucket
          region
          key
        }
        intervals {
          name
          duration
          timeType
          type
          id
        }
        classStatus
        classStatusString
        price
        startTime
        defaultBannerIndex
        classBookings {
          nextToken
          startedAt
        }
        stream {
          id
          isHostInStreamRoom
          classID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        playlist
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteTransaction = /* GraphQL */ `
  mutation DeleteTransaction(
    $input: DeleteTransactionInput!
    $condition: ModelTransactionConditionInput
  ) {
    deleteTransaction(input: $input, condition: $condition) {
      id
      credits
      classID
      finalCreditBalance
      initialCreditBalance
      type
      userID
      associatedClass {
        id
        userID
        instructor {
          id
          email
          username
          firstName
          lastName
          phoneNumber
          customerID
          accountID
          credits
          cognitoUserID
          userType
          userTypeString
          categoryFilter
          pushToken
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        name
        description
        date
        categoryFilter
        category {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        duration
        equipment
        banner {
          bucket
          region
          key
        }
        intervals {
          name
          duration
          timeType
          type
          id
        }
        classStatus
        classStatusString
        price
        startTime
        defaultBannerIndex
        classBookings {
          nextToken
          startedAt
        }
        stream {
          id
          isHostInStreamRoom
          classID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        playlist
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createReview = /* GraphQL */ `
  mutation CreateReview(
    $input: CreateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    createReview(input: $input, condition: $condition) {
      id
      review
      rating
      classID
      userID
      instructorID
      user {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateReview = /* GraphQL */ `
  mutation UpdateReview(
    $input: UpdateReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    updateReview(input: $input, condition: $condition) {
      id
      review
      rating
      classID
      userID
      instructorID
      user {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteReview = /* GraphQL */ `
  mutation DeleteReview(
    $input: DeleteReviewInput!
    $condition: ModelReviewConditionInput
  ) {
    deleteReview(input: $input, condition: $condition) {
      id
      review
      rating
      classID
      userID
      instructorID
      user {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createClassBooking = /* GraphQL */ `
  mutation CreateClassBooking(
    $input: CreateClassBookingInput!
    $condition: ModelClassBookingConditionInput
  ) {
    createClassBooking(input: $input, condition: $condition) {
      id
      classID
      userID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateClassBooking = /* GraphQL */ `
  mutation UpdateClassBooking(
    $input: UpdateClassBookingInput!
    $condition: ModelClassBookingConditionInput
  ) {
    updateClassBooking(input: $input, condition: $condition) {
      id
      classID
      userID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteClassBooking = /* GraphQL */ `
  mutation DeleteClassBooking(
    $input: DeleteClassBookingInput!
    $condition: ModelClassBookingConditionInput
  ) {
    deleteClassBooking(input: $input, condition: $condition) {
      id
      classID
      userID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createNotification = /* GraphQL */ `
  mutation CreateNotification(
    $input: CreateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    createNotification(input: $input, condition: $condition) {
      id
      userID
      createdAt
      pushToken
      content {
        title
        body
        data
      }
      type
      isNew
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateNotification = /* GraphQL */ `
  mutation UpdateNotification(
    $input: UpdateNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    updateNotification(input: $input, condition: $condition) {
      id
      userID
      createdAt
      pushToken
      content {
        title
        body
        data
      }
      type
      isNew
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteNotification = /* GraphQL */ `
  mutation DeleteNotification(
    $input: DeleteNotificationInput!
    $condition: ModelNotificationConditionInput
  ) {
    deleteNotification(input: $input, condition: $condition) {
      id
      userID
      createdAt
      pushToken
      content {
        title
        body
        data
      }
      type
      isNew
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createClass = /* GraphQL */ `
  mutation CreateClass(
    $input: CreateClassInput!
    $condition: ModelClassConditionInput
  ) {
    createClass(input: $input, condition: $condition) {
      id
      userID
      instructor {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      description
      date
      categoryFilter
      category {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      duration
      equipment
      banner {
        bucket
        region
        key
      }
      intervals {
        name
        duration
        timeType
        type
        id
      }
      classStatus
      classStatusString
      price
      startTime
      defaultBannerIndex
      classBookings {
        items {
          id
          classID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      stream {
        id
        isHostInStreamRoom
        classID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      playlist
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateClass = /* GraphQL */ `
  mutation UpdateClass(
    $input: UpdateClassInput!
    $condition: ModelClassConditionInput
  ) {
    updateClass(input: $input, condition: $condition) {
      id
      userID
      instructor {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      description
      date
      categoryFilter
      category {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      duration
      equipment
      banner {
        bucket
        region
        key
      }
      intervals {
        name
        duration
        timeType
        type
        id
      }
      classStatus
      classStatusString
      price
      startTime
      defaultBannerIndex
      classBookings {
        items {
          id
          classID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      stream {
        id
        isHostInStreamRoom
        classID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      playlist
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteClass = /* GraphQL */ `
  mutation DeleteClass(
    $input: DeleteClassInput!
    $condition: ModelClassConditionInput
  ) {
    deleteClass(input: $input, condition: $condition) {
      id
      userID
      instructor {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      name
      description
      date
      categoryFilter
      category {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      duration
      equipment
      banner {
        bucket
        region
        key
      }
      intervals {
        name
        duration
        timeType
        type
        id
      }
      classStatus
      classStatusString
      price
      startTime
      defaultBannerIndex
      classBookings {
        items {
          id
          classID
          userID
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      stream {
        id
        isHostInStreamRoom
        classID
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      playlist
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createStream = /* GraphQL */ `
  mutation CreateStream(
    $input: CreateStreamInput!
    $condition: ModelStreamConditionInput
  ) {
    createStream(input: $input, condition: $condition) {
      id
      isHostInStreamRoom
      classID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateStream = /* GraphQL */ `
  mutation UpdateStream(
    $input: UpdateStreamInput!
    $condition: ModelStreamConditionInput
  ) {
    updateStream(input: $input, condition: $condition) {
      id
      isHostInStreamRoom
      classID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteStream = /* GraphQL */ `
  mutation DeleteStream(
    $input: DeleteStreamInput!
    $condition: ModelStreamConditionInput
  ) {
    deleteStream(input: $input, condition: $condition) {
      id
      isHostInStreamRoom
      classID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createWaitList = /* GraphQL */ `
  mutation CreateWaitList(
    $input: CreateWaitListInput!
    $condition: ModelWaitListConditionInput
  ) {
    createWaitList(input: $input, condition: $condition) {
      id
      email
      teach
      take
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateWaitList = /* GraphQL */ `
  mutation UpdateWaitList(
    $input: UpdateWaitListInput!
    $condition: ModelWaitListConditionInput
  ) {
    updateWaitList(input: $input, condition: $condition) {
      id
      email
      teach
      take
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteWaitList = /* GraphQL */ `
  mutation DeleteWaitList(
    $input: DeleteWaitListInput!
    $condition: ModelWaitListConditionInput
  ) {
    deleteWaitList(input: $input, condition: $condition) {
      id
      email
      teach
      take
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createFavoriteInstructor = /* GraphQL */ `
  mutation CreateFavoriteInstructor(
    $input: CreateFavoriteInstructorInput!
    $condition: ModelFavoriteInstructorConditionInput
  ) {
    createFavoriteInstructor(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      instructorID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateFavoriteInstructor = /* GraphQL */ `
  mutation UpdateFavoriteInstructor(
    $input: UpdateFavoriteInstructorInput!
    $condition: ModelFavoriteInstructorConditionInput
  ) {
    updateFavoriteInstructor(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      instructorID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteFavoriteInstructor = /* GraphQL */ `
  mutation DeleteFavoriteInstructor(
    $input: DeleteFavoriteInstructorInput!
    $condition: ModelFavoriteInstructorConditionInput
  ) {
    deleteFavoriteInstructor(input: $input, condition: $condition) {
      id
      userID
      user {
        id
        email
        username
        firstName
        lastName
        phoneNumber
        avatar {
          bucket
          region
          key
        }
        customerID
        accountID
        credits
        files {
          nextToken
          startedAt
        }
        application {
          id
          username
          firstName
          lastName
          isInfluencer
          isTrainer
          isOwner
          submitted
          gymStudioName
          website
          userID
          lastIndex
          approved
          dateApproved
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        cognitoUserID
        classes {
          nextToken
          startedAt
        }
        profile {
          firstName
          lastName
          bio
          website
        }
        userType
        userTypeString
        classCategories {
          barre
          bound
          crossfit
          core
          circuitTraining
          dance
          HIIT
          kickBoxing
          meditation
          pilates
          power
          pregnancy
          sculpt
          strength
          stretch
          yoga
          zumba
          cardio
          endurance
          jump
          foamRoll
          run
          yogaSculpt
          restorative
          recovery
          strengthAndConditioning
          flow
          boxing
          celebrity
          weightLoss
          bodyWeight
          stability
          mobility
          functionalTraining
          glutes
          legs
          arms
          performanceTraining
          flexibility
          spiritualWellness
          wellness
          breathWork
          beginner
          advanced
          kettleBell
          tabata
          bodyBuilding
          athleteTraining
          cycling
          plusSize
          other
        }
        categoryFilter
        classBookings {
          nextToken
          startedAt
        }
        reviews {
          nextToken
          startedAt
        }
        favorites {
          nextToken
          startedAt
        }
        notifications {
          nextToken
          startedAt
        }
        transactions {
          nextToken
          startedAt
        }
        pushToken
        createdAt
        updatedAt
        _version
        _deleted
        _lastChangedAt
      }
      instructorID
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createTrainerApplication = /* GraphQL */ `
  mutation CreateTrainerApplication(
    $input: CreateTrainerApplicationInput!
    $condition: ModelTrainerApplicationConditionInput
  ) {
    createTrainerApplication(input: $input, condition: $condition) {
      id
      username
      firstName
      lastName
      isInfluencer
      isTrainer
      isOwner
      submitted
      location {
        city
        state
        zip
      }
      socials {
        instagram
        twitter
        facebook
        snapchat
        linkedin
      }
      gymStudioName
      website
      specializations {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      userID
      lastIndex
      gymStudioAddress {
        streetAddress
        city
        state
        zip
        country
      }
      files {
        items {
          id
          name
          ownerName
          trainerApplicationID
          userID
          fileType
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      approved
      dateApproved
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateTrainerApplication = /* GraphQL */ `
  mutation UpdateTrainerApplication(
    $input: UpdateTrainerApplicationInput!
    $condition: ModelTrainerApplicationConditionInput
  ) {
    updateTrainerApplication(input: $input, condition: $condition) {
      id
      username
      firstName
      lastName
      isInfluencer
      isTrainer
      isOwner
      submitted
      location {
        city
        state
        zip
      }
      socials {
        instagram
        twitter
        facebook
        snapchat
        linkedin
      }
      gymStudioName
      website
      specializations {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      userID
      lastIndex
      gymStudioAddress {
        streetAddress
        city
        state
        zip
        country
      }
      files {
        items {
          id
          name
          ownerName
          trainerApplicationID
          userID
          fileType
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      approved
      dateApproved
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteTrainerApplication = /* GraphQL */ `
  mutation DeleteTrainerApplication(
    $input: DeleteTrainerApplicationInput!
    $condition: ModelTrainerApplicationConditionInput
  ) {
    deleteTrainerApplication(input: $input, condition: $condition) {
      id
      username
      firstName
      lastName
      isInfluencer
      isTrainer
      isOwner
      submitted
      location {
        city
        state
        zip
      }
      socials {
        instagram
        twitter
        facebook
        snapchat
        linkedin
      }
      gymStudioName
      website
      specializations {
        barre
        bound
        crossfit
        core
        circuitTraining
        dance
        HIIT
        kickBoxing
        meditation
        pilates
        power
        pregnancy
        sculpt
        strength
        stretch
        yoga
        zumba
        cardio
        endurance
        jump
        foamRoll
        run
        yogaSculpt
        restorative
        recovery
        strengthAndConditioning
        flow
        boxing
        celebrity
        weightLoss
        bodyWeight
        stability
        mobility
        functionalTraining
        glutes
        legs
        arms
        performanceTraining
        flexibility
        spiritualWellness
        wellness
        breathWork
        beginner
        advanced
        kettleBell
        tabata
        bodyBuilding
        athleteTraining
        cycling
        plusSize
        other
      }
      userID
      lastIndex
      gymStudioAddress {
        streetAddress
        city
        state
        zip
        country
      }
      files {
        items {
          id
          name
          ownerName
          trainerApplicationID
          userID
          fileType
          createdAt
          updatedAt
          _version
          _deleted
          _lastChangedAt
        }
        nextToken
        startedAt
      }
      approved
      dateApproved
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const createFile = /* GraphQL */ `
  mutation CreateFile(
    $input: CreateFileInput!
    $condition: ModelFileConditionInput
  ) {
    createFile(input: $input, condition: $condition) {
      id
      name
      ownerName
      file {
        bucket
        region
        key
      }
      trainerApplicationID
      userID
      fileType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const updateFile = /* GraphQL */ `
  mutation UpdateFile(
    $input: UpdateFileInput!
    $condition: ModelFileConditionInput
  ) {
    updateFile(input: $input, condition: $condition) {
      id
      name
      ownerName
      file {
        bucket
        region
        key
      }
      trainerApplicationID
      userID
      fileType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile(
    $input: DeleteFileInput!
    $condition: ModelFileConditionInput
  ) {
    deleteFile(input: $input, condition: $condition) {
      id
      name
      ownerName
      file {
        bucket
        region
        key
      }
      trainerApplicationID
      userID
      fileType
      createdAt
      updatedAt
      _version
      _deleted
      _lastChangedAt
    }
  }
`;
